export const Colors = {
  SUCCESS: '#4CAF50',
  UNKNOWN: '#00BCD4',
  MINOR: '#FFC107',
  MAJOR: '#FFA500',
  CRITICAL: '#FF5252'
}

export const MarkerColors = {
  SUCCESS: Colors.SUCCESS.substring(1),
  UNKNOWN: Colors.UNKNOWN.substring(1),
  MINOR: Colors.MINOR.substring(1),
  MAJOR: Colors.MINOR.substring(1),
  CRITICAL: Colors.CRITICAL.substring(1)
}
